module.exports = __webpack_public_path__ + "static/media/vday1.d253af7f.jpeg";